import { Image } from "@mui/icons-material";
import React, { memo } from "react";
import { NodeCard } from "./commonNode";

const accent = "#ef5350";

export default memo(({ data, isConnectable, id }) => {
  const link =
    process.env.REACT_APP_BACKEND_URL === "http://localhost:8090"
      ? "http://localhost:8090"
      : process.env.REACT_APP_BACKEND_URL;

  return (
    <NodeCard
      id={id}
      title="Imagem"
      accent={accent}
      icon={<Image sx={{ width: 15, height: 15, color: accent }} />}
      isConnectable={isConnectable}
      width={220}
      targetTop="50%"
      sourceHandles={[{ id: "a", top: "82%" }]}
    >
      <img
        src={`${link}/public/${data.url}`}
        alt=""
        style={{
          width: "100%",
          height: 110,
          objectFit: "cover",
          display: "block",
          borderRadius: 6,
          background: `${accent}10`
        }}
      />
    </NodeCard>
  );
});
